import { TColors } from '@cian/ui-kit-design-tokens/colors';

import bonusSvg from './assets/bonus.svg';
import discountSvg from './assets/discount.svg';
import mortgageSvg from './assets/mortgage.svg';
import { EPromoLabelType } from '../../types/promos/promoLabel';

export const LABEL_BACKGROUNDS: Record<EPromoLabelType, TColors> = {
  [EPromoLabelType.Mortgage]: 'accent-main-secondary',
  [EPromoLabelType.NewbuildingCount]: 'overlay-control-dark',
  [EPromoLabelType.Discount]: 'surface-positive-default',
  [EPromoLabelType.Bonus]: 'surface-warning-default',
  [EPromoLabelType.Sale]: 'accent-main-primary',
};

export const LABEL_COLORS: Record<EPromoLabelType, TColors> = {
  [EPromoLabelType.Mortgage]: 'accent-main-primary',
  [EPromoLabelType.NewbuildingCount]: 'decorative-theme-dark',
  [EPromoLabelType.Discount]: 'accent-positive-primary',
  [EPromoLabelType.Bonus]: 'decorative-theme-orange',
  [EPromoLabelType.Sale]: 'decorative-theme-white',
};

export const LABEL_ICONS_MAP: Record<EPromoLabelType, string> = {
  [EPromoLabelType.Bonus]: bonusSvg,
  [EPromoLabelType.Discount]: discountSvg,
  [EPromoLabelType.Mortgage]: mortgageSvg,
  [EPromoLabelType.NewbuildingCount]: '',
  [EPromoLabelType.Sale]: '',
};
